export default "__VITE_ASSET__DwWFo1kQ__"